/** Measured controller positions at the two physical lift endpoints (metres). */
export interface LiftCalibration {
  bottom: number;
  top: number;
}

export const LIFT_CALIBRATION_KEY = "mmr.robotModel.pantherLiftCalibration.v1";

/** Restore the feedback origin after a controller restart, keeping measured travel. */
export function rebaseLiftCalibration(
  calibration: LiftCalibration,
  endpoint: "bottom" | "top",
  position: number
): LiftCalibration {
  const offset = position - calibration[endpoint];
  return { bottom: calibration.bottom + offset, top: calibration.top + offset };
}

export function isLiftCalibration(value: unknown): value is LiftCalibration {
  if (!value || typeof value !== "object") return false;
  const { bottom, top } = value as LiftCalibration;
  return Number.isFinite(bottom) && Number.isFinite(top) && Math.abs(top - bottom) >= 0.02;
}

/** Panther's visual URDF: lower joint limit is the raised pose, upper is lowered.
 * Endpoint capture determines the controller's direction without assuming its zero. */
export function calibratedLiftPosition(
  position: number,
  calibration: LiftCalibration,
  lower: number,
  upper: number
): number {
  const raised = Math.max(
    0,
    Math.min(1, (position - calibration.bottom) / (calibration.top - calibration.bottom))
  );
  return upper + raised * (lower - upper);
}

export function readLiftCalibration(): LiftCalibration | null {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(LIFT_CALIBRATION_KEY) ?? "null");
    return isLiftCalibration(value) ? value : null;
  } catch {
    return null;
  }
}
